/**
 * Passed as a value to the 'adType' option
 */ export var AdType = /*#__PURE__*/ function(AdType) {
    AdType["VodAd"] = "VodAd";
    AdType["Ad"] = "Ad";
    return AdType;
}({});
export var AdvertisingContentType = /*#__PURE__*/ function(AdvertisingContentType) {
    AdvertisingContentType["Advert"] = "Advert";
    AdvertisingContentType["Other"] = "Other";
    return AdvertisingContentType;
}({});
export var AdContentType = /*#__PURE__*/ function(AdContentType) {
    AdContentType["Promotional"] = "Promotional";
    AdContentType["Advertisement"] = "Advertisement";
    return AdContentType;
}({});

//# sourceMappingURL=adverts.enums.js.map